import React from 'react'
import { Link } from 'react-router-dom';
import * as icons from 'react-icons/lib/md';
import * as routes from '../../constants/routes';

import { doSignOut } from '../../session';
import './styles.css';

class Menu extends React.Component{
	constructor(props){
	    super(props);
	    // This binding is necessary to make `this` work in the callback
	    this.showMore = this.showMore.bind(this);
	    this.toggle = this.toggle.bind(this);
	    this.doSignOut = this.doSignOut.bind(this);
	  }

	 componentWillUpdate(S){
	 	
	 }

	showMore(e){
		e.preventDefault();
	    this.toggle();
	  }

	  doSignOut(e){
		e.preventDefault();
		doSignOut();
		this.props.history.push(routes.SIGN_IN);
	}

	toggle(s){
	 	let menu = document.getElementById("menu")
	 	menu.className = (s!==undefined?s:menu.className!=='open') ? 'open' : ''
	}

	render(){
		const HomeIcon = icons.MdEqualizer;
		const CarIcon = icons.MdTimeToLeave;
		const MoreIcon = icons.MdMoreVert;
		const connected_state = this.props.online?"online":"offline";
		if(this.props.isSignedIn){
			return (
				<aside id="menu">
					<div>	
						<span id="online-status">
							<span id="connection-state" className={connected_state}></span>
							{connected_state}
						</span>
						<nav id="main-nav">
							<Link to="/"><HomeIcon/></Link>
							<Link to="/entry/cars"><CarIcon/></Link>
							<a href="/" onClick={this.showMore}><MoreIcon/></a>
						</nav>
					</div>
					<nav id="sub-nav">
						<a id="sign-out" href="/" onClick={this.doSignOut}>sign out</a>
					</nav>
				</aside>

			)
	    } else {
			return null;
		}
	}
}
 
export default Menu


// WEBPACK FOOTER //
// ./src/components/Menu/index.js